import React, { useEffect, useState } from 'react';
import './SplashScreen.css';

const SplashScreen = () => {
    const [progress, setProgress] = useState(0);
    const [currentText, setCurrentText] = useState(0);
    const [isVisible, setIsVisible] = useState(false);

    const loadingTexts = [
        "Initializing Aethrx...",
        "Connecting to Markets...",
        "Loading Your Portfolio...",
        "Almost Ready..."
    ];

    useEffect(() => {
        // Show splash screen with fade in
        setTimeout(() => setIsVisible(true), 100);

        // Simulate progress with smoother animation
        const progressInterval = setInterval(() => {
            setProgress(prev => {
                if (prev >= 100) {
                    clearInterval(progressInterval);
                    return 100;
                }
                return prev + Math.random() * 8 + 2; // More realistic progress
            });
        }, 150);

        // Cycle through loading texts
        const textInterval = setInterval(() => {
            setCurrentText(prev => (prev + 1) % loadingTexts.length);
        }, 2000);

        return () => {
            clearInterval(progressInterval);
            clearInterval(textInterval);
        };
    }, []);

    return (
        <div className={`splash-screen ${isVisible ? 'visible' : ''}`}>
            {/* Animated Background */}
            <div className="splash-background">
                <div className="gradient-orb orb-1"></div>
                <div className="gradient-orb orb-2"></div>
                <div className="gradient-orb orb-3"></div>
                <div className="grid-overlay"></div>
            </div>

            {/* Floating Particles */}
            <div className="particles-container">
                {[...Array(15)].map((_, i) => (
                    <div
                        key={i}
                        className="particle"
                        style={{
                            '--delay': `${Math.random() * 4}s`,
                            '--duration': `${3 + Math.random() * 3}s`,
                            '--size': `${4 + Math.random() * 6}px`,
                            '--x-start': `${Math.random() * 100}%`,
                            '--x-end': `${Math.random() * 100}%`
                        }}
                    ></div>
                ))}
            </div>

            {/* Main Content */}
            <div className="splash-content">
                {/* Logo Section */}
                <div className="logo-section">
                    <div className="logo-container">
                        <div className="logo-glow"></div>
                        <div className="logo-main">
                            <div className="logo-inner">
                                <img src="/favicon.png" alt="Aethrx" className="logo-favicon" />
                            </div>
                        </div>
                        <div className="logo-rings">
                            <div className="ring ring-1"></div>
                            <div className="ring ring-2"></div>
                            <div className="ring ring-3"></div>
                        </div>
                    </div>
                </div>

                {/* Loading Section */}
                <div className="loading-section">
                    <div className="loading-text-container">
                        <div className="loading-text">
                            {loadingTexts[currentText]}
                        </div>
                        <div className="loading-dots">
                            <span></span>
                            <span></span>
                            <span></span>
                        </div>
                    </div>

                    <div className="progress-section">
                        <div className="splash-progress-container">
                            <div className="progress-bar">
                                <div
                                    className="progress-fill"
                                    style={{ width: `${progress}%` }}
                                ></div>
                                <div className="progress-glow"></div>
                            </div>
                            <div className="progress-text">{Math.round(progress)}%</div>
                        </div>
                    </div>
                </div>


            </div>
        </div>
    );
};

export default SplashScreen;
